export default __webpack_public_path__ + "static/media/image-1.1e75a301.jpg";